export enum ROLES {
  ROLE_ADMIN = 'ROLE_ADMIN',
}
